import { createAction } from '@reduxjs/toolkit';

export const nativeClientPushNotificationReceived = createAction(
    'NATIVE_CLIENT::PUSH_NOTIFICATION_RECEIVED',
);
